<template lang="pug">
.container-item
    .container-icon
        img(:src='buscarUrlImagem(icone)')
    span.etapa {{ etapa }}

    .lista-scroll
        .historico(v-for='historico in dadosHistorico', :key='historico.id')
            .historico-item
                span.info Data: {{ historico.data }}
                span.info Número:  {{ historico.numero }}

</template>
<script>
export default {
    name: 'ItemHistorico',
    props: {
        dadosHistorico: {
            type: Array,
            default: () => {}
        },

        etapa: {
            type: String,
            default: () => ''
        },
        icone: {
            type: String,
            default: () => ''
        }
    },
    methods: {
        buscarUrlImagem(icone) {
            return require(`@/assets/raizen-icons/rastreabilidade/${icone}.png`);
        }
    }
};
</script>
<style lang="scss">
.container-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 15vh;
}
.etapa {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #00413C;
}
.info {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #3B3B3B;
}

.historico-item {
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
}

.lista-scroll {
    max-height: 200px;
    overflow-y: auto;
    flex-direction: column;
    margin-top: 10px;
    padding: 5px 10px;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: var(--text-disabled);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }
}
</style>
